import { render, staticRenderFns } from "./PhoneCredit.vue?vue&type=template&id=71fc8a07&scoped=true&"
import script from "./PhoneCredit.vue?vue&type=script&lang=js&"
export * from "./PhoneCredit.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCredit.vue?vue&type=style&index=0&id=71fc8a07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc8a07",
  null
  
)

export default component.exports